import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AysVirtualClinic } from '@bindoc-projects/virtual-clinic-domain-lib';
import { AysVirtualClinicSelectInlineComponent } from '@bindoc-projects/virtual-clinic-lib/ui';
import { BdResourcesSelectInlineConfig } from '@bindoc-projects/resource-lib/data';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';

@Component({
  selector: 'ays-virtual-clinic-kost-new-virtual-clinic',
  template: `
    <ays-virtual-clinic-select-inline
      [virtualClinicId]="virtualClinicId"
      [shareableType]="resourceName"
      [options]="virtualClinicSelectOptions"
      (virtualClinicSelect)="onVirtualClinicSelect($event)"
    >
    </ays-virtual-clinic-select-inline>
  `,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AysVirtualClinicSelectInlineComponent],
})
export class VirtualClinicKostNewVirtualClinicComponent {
  @Input()
  public virtualClinicId: string;

  @Input()
  public virtualClinicSelectOptions: BdResourcesSelectInlineConfig<AysVirtualClinic>;

  @Input()
  public resourceName: ShareableType;

  public readonly virtualClinicIdChange = output<string>();

  public virtualClinic: AysVirtualClinic;

  public onVirtualClinicSelect(virtualClinic: AysVirtualClinic | null) {
    if (virtualClinic) {
      this.virtualClinic = virtualClinic;
      this.virtualClinicId = virtualClinic.id;

      this.virtualClinicIdChange.emit(virtualClinic.id);
    }
  }
}
